/* Progressive enhancement: cart, search, filters and contact use native Shopify forms. */
(() => {
  'use strict';
  const initialized = new WeakSet();
  function setupProduct(section) {
    if (initialized.has(section)) return;
    initialized.add(section);
    const select = section.querySelector('[data-variant-selector]');
    const panels = [...section.querySelectorAll('[data-media-id]')];
    const thumbs = [...section.querySelectorAll('[data-media-target]')];
    function showMedia(id) {
      const target = panels.find(panel => panel.dataset.mediaId === String(id));
      if (!target) return;
      panels.forEach(panel => {
        panel.hidden = panel !== target;
        if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
        // Stop an externally hosted video when leaving its media panel.
        if (panel.hidden) panel.querySelectorAll('iframe').forEach(frame => {
          if (frame.dataset.active === 'true') frame.src = frame.src;
          frame.dataset.active = 'false';
        });
        else panel.querySelectorAll('iframe').forEach(frame => { frame.dataset.active = 'true'; });
      });
      thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
    }
    if (panels.length) showMedia(section.dataset.currentMedia || panels[0].dataset.mediaId);
    const thumbList = section.querySelector('[data-gallery-thumbs]');
    if (thumbList) thumbList.hidden = false;
    thumbs.forEach(button => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const data = option.dataset;
      const price = section.querySelector('[data-variant-price]');
      const compare = section.querySelector('[data-variant-compare]');
      price.textContent = data.price || '';
      compare.textContent = data.compare || '';
      compare.hidden = !data.compare;
      const unit = section.querySelector('[data-unit-price]');
      unit.textContent = data.unit || '';
      unit.hidden = !data.unit;
      const sku = section.querySelector('[data-variant-sku]');
      sku.textContent = data.sku || '';
      section.querySelector('[data-sku-row]').hidden = !data.sku;
      const quantity = section.querySelector('[name="quantity"]');
      const min = Number(data.min) || 1;
      const step = Number(data.step) || 1;
      quantity.min = String(min);
      quantity.step = String(step);
      if (data.max) quantity.max = data.max;
      else quantity.removeAttribute('max');
      quantity.value = String(min);
      const rule = section.querySelector('[data-quantity-rule]');
      rule.textContent = data.rule || '';
      rule.hidden = min === 1 && step === 1;
      const add = section.querySelector('[data-add-to-cart]');
      add.disabled = data.available !== 'true' || section.dataset.subscriptionOnly === 'true';
      add.textContent = data.available === 'true' ? section.dataset.addLabel : section.dataset.soldLabel;
      showMedia(data.media || section.dataset.currentMedia);
      // Do not rewrite the editor URL when Shopify embeds the section in its editor.
      if (!window.Shopify?.designMode) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    });
  }
  function init(root = document) {
    if (root.matches?.('[data-product-section]')) setupProduct(root);
    root.querySelectorAll('[data-product-section]').forEach(setupProduct);
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = [...document.querySelectorAll('.mobile-nav[open], .nav-dropdown[open], .filters[open]')];
    open.forEach(details => {
      details.open = false;
      if (details.contains(document.activeElement)) details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.mobile-nav[open], .nav-dropdown[open], .filters[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
